import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from "apps/website/src/environments/environment";

export enum DataFieldType {
  DROPACTION = "dropaction",
  TEXT = "text",
  ACTION = "action",
  VIEWACTION = "viewaction",
  DROPTEXTACTION = 'droptext',
  LINK = "link",
  HTML = "html",
  TOGGLE = "toggle"
}

export enum ALIGNMENT {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  CENTER = "CENTER"
}

export interface TabelClickAction {
  data: any;
  type: DataFieldType;
  actionEvent: any;
}

export interface StatusPermission {
  STAFF: boolean,
  PROJECT_MANAGERS: boolean,
  HUMAN_RESOURCES: boolean,
  BUSINESS_LEADERS: boolean,
  INFRASTRUCTURE_TEAM: boolean,
  ACCOUNT: boolean
}

export interface DataField {
  field: string;
  label: string;
  type: DataFieldType;
  btnTypes?: string[];
  actionBtn?: string[];
  actionBtnMoreOptions?: { value: string, label: string, keyname?: string, label2?: string }[],
  textBtn?: string[];
  align?: ALIGNMENT;
  width?: string;
  isEdit?: boolean;
  isDelete?: boolean;
  isCancel?: boolean;
  isAccept?: boolean;
  isAssignJob?: boolean;
  isUpload?: boolean;
  isGenInvoice?: boolean;
  sortable?: boolean;
  isCall?: boolean;
  isReport?: boolean;
  isStatusCheckFalse?: boolean;
  disableLimitText?: boolean;
  toggleActiveValue?: string;
}

@Component({
  selector: "intrasense-table-ui",
  templateUrl: "./table-ui.component.html",
  styleUrls: ["./table-ui.component.scss"],
})
export class TableUiComponent implements OnInit {
  @Input() height: string = "55vh";
  @Input() dataFields: DataField[] = [];
  @Input() dataSource: any[] = [];
  @Input() isHoverable: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() isFullRow: boolean = false;
  @Output() onRowClicked = new EventEmitter<any>();
  @Output() onActionClicked = new EventEmitter<any>();
  @Output() sort = new EventEmitter<string>();
  sorting: boolean = false;
  /*--Pagination--*/
  @Input() totalRecords: number = 0;
  @Input() itemsPerPage: number = environment.itemsPerPage;
  @Input() currentPage: number = 0;
  @Input() enablePagination: boolean = false;
  @Output() onPageChange = new EventEmitter<{ pageIndex: number; pageSize: number }>();
  totalPages: number = 0;
  currentPageGroup: number = 0;
  goToPageInput: number = 1;
  pageButtons: number[] = [];
  /*--/end pagination--*/
  constructor() { }

  ngOnInit(): void { }

  clickHandler(index: number) {
    if (this.dataSource[index]) {
      const body = {
        data: this.dataSource[index],
        type: DataFieldType.LINK,
        actionEvent: "ROWCLICKED",
      };
      this.onRowClicked.emit(body);
    }
  }

  clickActionHandler(event: any) {
    if (this.dataSource[event.index$] && event.type$) {
      const body = {
        data: this.dataSource[event.index$],
        type: event.type$,
        actionEvent: event.actionEvent$,
      };
      this.onActionClicked.emit(body);
    }
  }

  sortTable() {
    this.sorting = !this.sorting;
    if (this.sorting) {
      this.sort.emit('des')
    } else {
      this.sort.emit('asc')
    }
  }

  /*--Pagination scripts--*/
  ngOnChanges(): void {
    this.totalPages = Math.ceil(this.totalRecords / this.itemsPerPage);
    // Update current page group if parent changed page
    this.currentPageGroup = Math.floor(this.currentPage / this.itemsPerPage);
    this.goToPageInput = this.currentPage + 1;
    this.generatePageButtons();
  }

  generatePageButtons(): void {
    const start = this.currentPageGroup * this.itemsPerPage;
    const end = Math.min(start + this.itemsPerPage, this.totalPages);
    //const end = Math.min(start + (this.isMobile ? 3 : 10), this.totalPages);
    this.pageButtons = [];
    for (let i = start; i < end; i++) {
      this.pageButtons.push(i);
    }
  }

  goToPage(pageIndex: number): void {
    if (pageIndex >= 0 && pageIndex < this.totalPages) {
      this.onPageChange.emit({ pageIndex, pageSize: this.itemsPerPage });
    }
  }

  goToPreviousGroup(): void {
    if (this.currentPageGroup > 0) {
      this.goToPage((this.currentPageGroup - 1) * this.itemsPerPage);
    }
  }

  goToNextGroup(): void {
    const nextGroupStart = (this.currentPageGroup + 1) * this.itemsPerPage;
    if (nextGroupStart < this.totalPages) {
      this.goToPage(nextGroupStart);
    }
  }

  goToFirst(): void {
    this.goToPage(0);
  }

  goToLast(): void {
    this.goToPage(this.totalPages - 1);
  }

  handleGoToPageInput(): void {
    const page = this.goToPageInput - 1;
    this.goToPage(page);
  }

  isActive(pageIndex: number): boolean {
    return pageIndex === this.currentPage;
  }
  /*--/end pagination scripts--*/
  /*--Next Group Tooltip--*/
  getNextGroupTooltip(): string {
    const nextGroup = this.currentPageGroup + 1;
    // If next group's first page exceeds totalPages, don't show tooltip
    const startPage = nextGroup * this.itemsPerPage + 1;
    if (startPage > this.totalPages) {
      return '';
    }
    const endPage = Math.min((nextGroup + 1) * this.itemsPerPage, this.totalPages);
    return `From page ${startPage} - ${endPage}`;
  }
  /*--Previous Group Tooltip--*/
  getPreviousGroupTooltip(): string {
    const prevGroup = this.currentPageGroup - 1;
    // If already on the first group, there's no previous group
    if (prevGroup < 0) {
      return '';
    }
    const startPage = prevGroup * this.itemsPerPage + 1;
    const endPage = (this.currentPageGroup * this.itemsPerPage);
    return `From page ${startPage} - ${endPage}`;
  }
  /*--First Page ToolTip--*/
  getFirstpageToolTip(): string {
    const firstPage = this.currentPage;
    if (firstPage != 0) {
      return "First page";
    } else {
      return "";
    }
  }
  /*--Last Page ToolTip--*/
  getLastpageToolTip() {
    const lastPage = this.totalPages;
    if (this.currentPage != lastPage - 1) {
      return "Last page";
    } else {
      return "";
    }
  }

}
